// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-bot-title {
    font-size: 20px;
    margin: 0px;
    padding: 0px;
    margin-bottom: 15px;
    text-align: center;
    font-weight: 600;
    columns: #505050;
}

/* ----------  LAYOUT SECTIONS  ---------- */
.add-bot-section {
    margin-bottom: 25px;
}

.control-group-add-bot-toggle {
    margin-top: 10px;
}

.javascript-render-info-icon {
    color: #5616ea;
}

.tab-header-content {
    display: flex;
    align-items: center;
    gap: 6px;
    color: #2c2c2c;
}

.tab-header-content-icon {
    color: #505050;
}

.file-upload-container {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.file-drag-drop {
    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: center;
    font-size: 18px;
}

.add-bot-file-tag-parent {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 5px;
}

.add-bot-file-tag {
    display: inline-block;
    padding: 5px;
    padding-left: 7px;
    padding-right: 7px;
    padding-top: 1px;
    padding-bottom: 2px;
    border-radius: 10px;
    background-color: #e2e2e2;
    color: #3a3a3a;
    font-size: 14px;
}

.upload-files-button {
    padding: 10px;
    border-radius: 8px;
    outline: none;
    border: 1px solid grey;
    min-width: 200px;
    max-width: 300px;
    align-self: center;
    font-size: 14px;
    cursor: pointer;
    transition: 0.2s ease, color 0.2s ease;
}

.upload-files-button:hover {
    background-color: #ddd;
    border: 1px solid rgb(40, 40, 40);
}

.upload-file-input {
    padding: 10px;
    background-color: rgba(238, 238, 238, 0.393);
    border-radius: 8px;
    border: 1px solid rgb(196, 196, 196);
    cursor: pointer;
    font-size: 15px;
}

.upload-file-input:hover {
    border: 1px solid rgb(93, 93, 93);
}

.file-parent-container {
    display: flex;
    flex-direction: column;
    gap: 20px;
    max-height: 400px;
    overflow: auto;
}

.file-content {
    display: flex;
    align-items: center;
    text-align: center;
    line-height: 1;
}

.files-container {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.valid-file {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #efefef;
    padding: 5px 10px;
    border-radius: 8px;
    font-size: 14px;
    color: #292929;
    word-break: break-all;
    text-align: left;
}

.invalid-header-text {
    text-align: left;
    font-weight: 600;
}

.invalid-file {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #ffeaea;
    padding: 5px 10px;
    border-radius: 8px;
    font-size: 14px;
    color: #292929;
    word-break: break-all;
    text-align: left;
}

.validation-error-container {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px;
    border-radius: 8px;
    position: relative;
    background-color: #ffcaca;
    font-weight: 600;
    margin-bottom: 15px;
}

.icon-title-container {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    gap: 8px;
}

.add-bot-section-title {
    margin: 0;
    font-weight: 600;
}

.add-bot-section-icon {
    color: #5616ea;
    margin-top: 0px;
}

.add-bot-required-field {
    font-weight: 800;
    color: #5616ea;
    font-size: 18px;
}

.countdown-ring .ring-bg {
    stroke-dasharray: 63;
    stroke-dashoffset: 0;
    transform: rotate(-90deg);
    transform-origin: center;
    animation: countdown 10s linear forwards;
}

@keyframes countdown {
    from {
        stroke-dashoffset: 0;
    }
    to {
        stroke-dashoffset: 63;
    }
}

@media (max-width: 768px) {
    .file-parent-container {
        max-height: 380px;
    }
}

/* ── Hosting gate ──────────────────────────────────────────────────────────
   Shown before the form: the Webflow answer decides whether this agent can
   ever be trained from a website address, so it is asked first.
   Layout: question + close on one line, then the logo, then the two options. */
.add-bot-hosting-gate {
    position: relative;
    padding-top: 2px;
    /* The gate is the only content in the modal, so the 25px section spacing
       inherited from .add-bot-section would stack on top of the modal padding
       and leave a visible gap under the two options. */
    margin-bottom: 0;
}

.add-bot-hosting-gate-head {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 28px;
}

.add-bot-hosting-gate-title {
    margin: 0;
    padding: 0 30px;
    text-align: center;
    font-weight: 600;
    font-size: 1.05rem;
    line-height: 1.3;
}

/* Same affordance as the chat modal's close button. Absolutely positioned so
   the title stays centred on the modal, not on the leftover space. */
.add-bot-close-btn {
    position: absolute;
    top: 50%;
    right: -6px;
    transform: translateY(-50%);
    background: none;
    border: none;
    font-size: 20px;
    color: #888;
    cursor: pointer;
    padding: 2px 6px;
    border-radius: 6px;
    transition: all 0.2s ease;
    line-height: 1;
}

.add-bot-close-btn:hover {
    background: #f0f0f0;
    color: #333;
}

.add-bot-hosting-gate-logo {
    display: block;
    width: 74px;
    height: 74px;
    object-fit: contain;
    margin: 22px auto 18px auto;
}

.add-bot-hosting-gate-hint {
    margin: 0 0 20px 0;
    text-align: center;
    color: #6b6b76;
    font-size: 0.9rem;
    line-height: 1.45;
}

.add-bot-hosting-gate-actions {
    display: flex;
    gap: 10px;
}

.add-bot-hosting-note {
    display: flex;
    align-items: center;
    gap: 8px;
    background: #f5f2ff;
    border: 1px solid #e2d9ff;
    border-radius: 8px;
    padding: 10px 12px;
    margin-bottom: 18px;
    color: #4a4658;
    font-size: 0.87rem;
    line-height: 1.4;
}

.add-bot-hosting-note-logo {
    width: 18px;
    height: 18px;
    object-fit: contain;
    flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/addBotModal.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,4CAA4C;AAC5C;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,sBAAsB;IACtB,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,4CAA4C;IAC5C,kBAAkB;IAClB,oCAAoC;IACpC,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,yBAAyB;IACzB,wBAAwB;IACxB,wCAAwC;AAC5C;;AAEA;IACI;QACI,oBAAoB;IACxB;IACA;QACI,qBAAqB;IACzB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;;;+EAG+E;AAC/E;IACI,kBAAkB;IAClB,gBAAgB;IAChB;;uDAEmD;IACnD,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;qEACqE;AACrE;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;AAClB","sourcesContent":[".add-bot-title {\r\n    font-size: 20px;\r\n    margin: 0px;\r\n    padding: 0px;\r\n    margin-bottom: 15px;\r\n    text-align: center;\r\n    font-weight: 600;\r\n    columns: #505050;\r\n}\r\n\r\n/* ----------  LAYOUT SECTIONS  ---------- */\r\n.add-bot-section {\r\n    margin-bottom: 25px;\r\n}\r\n\r\n.control-group-add-bot-toggle {\r\n    margin-top: 10px;\r\n}\r\n\r\n.javascript-render-info-icon {\r\n    color: #5616ea;\r\n}\r\n\r\n.tab-header-content {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n    color: #2c2c2c;\r\n}\r\n\r\n.tab-header-content-icon {\r\n    color: #505050;\r\n}\r\n\r\n.file-upload-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 20px;\r\n}\r\n\r\n.file-drag-drop {\r\n    display: flex;\r\n    gap: 10px;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-size: 18px;\r\n}\r\n\r\n.add-bot-file-tag-parent {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    justify-content: center;\r\n    gap: 5px;\r\n}\r\n\r\n.add-bot-file-tag {\r\n    display: inline-block;\r\n    padding: 5px;\r\n    padding-left: 7px;\r\n    padding-right: 7px;\r\n    padding-top: 1px;\r\n    padding-bottom: 2px;\r\n    border-radius: 10px;\r\n    background-color: #e2e2e2;\r\n    color: #3a3a3a;\r\n    font-size: 14px;\r\n}\r\n\r\n.upload-files-button {\r\n    padding: 10px;\r\n    border-radius: 8px;\r\n    outline: none;\r\n    border: 1px solid grey;\r\n    min-width: 200px;\r\n    max-width: 300px;\r\n    align-self: center;\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n    transition: 0.2s ease, color 0.2s ease;\r\n}\r\n\r\n.upload-files-button:hover {\r\n    background-color: #ddd;\r\n    border: 1px solid rgb(40, 40, 40);\r\n}\r\n\r\n.upload-file-input {\r\n    padding: 10px;\r\n    background-color: rgba(238, 238, 238, 0.393);\r\n    border-radius: 8px;\r\n    border: 1px solid rgb(196, 196, 196);\r\n    cursor: pointer;\r\n    font-size: 15px;\r\n}\r\n\r\n.upload-file-input:hover {\r\n    border: 1px solid rgb(93, 93, 93);\r\n}\r\n\r\n.file-parent-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 20px;\r\n    max-height: 400px;\r\n    overflow: auto;\r\n}\r\n\r\n.file-content {\r\n    display: flex;\r\n    align-items: center;\r\n    text-align: center;\r\n    line-height: 1;\r\n}\r\n\r\n.files-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 8px;\r\n}\r\n\r\n.valid-file {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    background-color: #efefef;\r\n    padding: 5px 10px;\r\n    border-radius: 8px;\r\n    font-size: 14px;\r\n    color: #292929;\r\n    word-break: break-all;\r\n    text-align: left;\r\n}\r\n\r\n.invalid-header-text {\r\n    text-align: left;\r\n    font-weight: 600;\r\n}\r\n\r\n.invalid-file {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    background-color: #ffeaea;\r\n    padding: 5px 10px;\r\n    border-radius: 8px;\r\n    font-size: 14px;\r\n    color: #292929;\r\n    word-break: break-all;\r\n    text-align: left;\r\n}\r\n\r\n.validation-error-container {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n    padding: 10px;\r\n    border-radius: 8px;\r\n    position: relative;\r\n    background-color: #ffcaca;\r\n    font-weight: 600;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.icon-title-container {\r\n    display: flex;\r\n    align-items: center;\r\n    margin-bottom: 15px;\r\n    gap: 8px;\r\n}\r\n\r\n.add-bot-section-title {\r\n    margin: 0;\r\n    font-weight: 600;\r\n}\r\n\r\n.add-bot-section-icon {\r\n    color: #5616ea;\r\n    margin-top: 0px;\r\n}\r\n\r\n.add-bot-required-field {\r\n    font-weight: 800;\r\n    color: #5616ea;\r\n    font-size: 18px;\r\n}\r\n\r\n.countdown-ring .ring-bg {\r\n    stroke-dasharray: 63;\r\n    stroke-dashoffset: 0;\r\n    transform: rotate(-90deg);\r\n    transform-origin: center;\r\n    animation: countdown 10s linear forwards;\r\n}\r\n\r\n@keyframes countdown {\r\n    from {\r\n        stroke-dashoffset: 0;\r\n    }\r\n    to {\r\n        stroke-dashoffset: 63;\r\n    }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .file-parent-container {\r\n        max-height: 380px;\r\n    }\r\n}\r\n\r\n/* ── Hosting gate ──────────────────────────────────────────────────────────\r\n   Shown before the form: the Webflow answer decides whether this agent can\r\n   ever be trained from a website address, so it is asked first.\r\n   Layout: question + close on one line, then the logo, then the two options. */\r\n.add-bot-hosting-gate {\r\n    position: relative;\r\n    padding-top: 2px;\r\n    /* The gate is the only content in the modal, so the 25px section spacing\r\n       inherited from .add-bot-section would stack on top of the modal padding\r\n       and leave a visible gap under the two options. */\r\n    margin-bottom: 0;\r\n}\r\n\r\n.add-bot-hosting-gate-head {\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    min-height: 28px;\r\n}\r\n\r\n.add-bot-hosting-gate-title {\r\n    margin: 0;\r\n    padding: 0 30px;\r\n    text-align: center;\r\n    font-weight: 600;\r\n    font-size: 1.05rem;\r\n    line-height: 1.3;\r\n}\r\n\r\n/* Same affordance as the chat modal's close button. Absolutely positioned so\r\n   the title stays centred on the modal, not on the leftover space. */\r\n.add-bot-close-btn {\r\n    position: absolute;\r\n    top: 50%;\r\n    right: -6px;\r\n    transform: translateY(-50%);\r\n    background: none;\r\n    border: none;\r\n    font-size: 20px;\r\n    color: #888;\r\n    cursor: pointer;\r\n    padding: 2px 6px;\r\n    border-radius: 6px;\r\n    transition: all 0.2s ease;\r\n    line-height: 1;\r\n}\r\n\r\n.add-bot-close-btn:hover {\r\n    background: #f0f0f0;\r\n    color: #333;\r\n}\r\n\r\n.add-bot-hosting-gate-logo {\r\n    display: block;\r\n    width: 74px;\r\n    height: 74px;\r\n    object-fit: contain;\r\n    margin: 22px auto 18px auto;\r\n}\r\n\r\n.add-bot-hosting-gate-hint {\r\n    margin: 0 0 20px 0;\r\n    text-align: center;\r\n    color: #6b6b76;\r\n    font-size: 0.9rem;\r\n    line-height: 1.45;\r\n}\r\n\r\n.add-bot-hosting-gate-actions {\r\n    display: flex;\r\n    gap: 10px;\r\n}\r\n\r\n.add-bot-hosting-note {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    background: #f5f2ff;\r\n    border: 1px solid #e2d9ff;\r\n    border-radius: 8px;\r\n    padding: 10px 12px;\r\n    margin-bottom: 18px;\r\n    color: #4a4658;\r\n    font-size: 0.87rem;\r\n    line-height: 1.4;\r\n}\r\n\r\n.add-bot-hosting-note-logo {\r\n    width: 18px;\r\n    height: 18px;\r\n    object-fit: contain;\r\n    flex-shrink: 0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
